import EpisodePageMetadata from './EpisodePageMetadata';

export default EpisodePageMetadata;
